// A document opened from an artifact's citation is a source view, one level
// deep (Gerry, 2026-10-06): the pane shows one thing at a time, so the
// cited document takes the artifact's place, and its header leads with the
// way back to that artifact. The record of where it came from rides with the
// document's open (the viewer's `fileViewerData.sourceOf`), so every host
// that draws the document (the app's pane, the run page's card) draws the
// same way back.

/** The artifact a source view returns to, and what the citation named. */
export interface SourceOrigin {
  /** The artifact's title, as its own pane header showed it. */
  title: string;
  /** The artifact's type tile. */
  badge: { ext: string; kind: string };
  /** The `openDocumentPanel` detail that puts the artifact back in the pane,
   *  the same shape its own open sent (`paneDetailFor`). */
  reopen: Record<string, unknown>;
  /** The cited page, when the citation named one. */
  pageNum: number | null;
}

/** Puts the artifact back in the pane, as it was opened. */
export const returnToSourceArtifact = (origin: SourceOrigin): void => {
  window.dispatchEvent(
    new CustomEvent("openDocumentPanel", { detail: origin.reopen })
  );
};

/** The source view's tag: "Source", with the cited page when there is one. */
export const sourceTagLabel = (origin: SourceOrigin): string =>
  origin.pageNum !== null ? `Source · p. ${origin.pageNum}` : "Source";
